import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AdministrativeIndicationsReportService, IndicationScheduleOption } from '../../../../../../services/administrative-indications-report-v2.service';

@Component({
    selector: 'app-attach-report-modal',
    templateUrl: './attach-report.modal.html',
    styleUrls: ['./attach-report.modal.scss'],

})
export class AttachReportModalComponent implements OnInit {
    schedules: IndicationScheduleOption[] = [];
    loadingSchedules = false;
    attachedAny = false;

    constructor(
        private readonly dialogRef: MatDialogRef<AttachReportModalComponent>,
        private readonly service: AdministrativeIndicationsReportService,
        private readonly snack: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: { row: any }
    ) {}

    ngOnInit(): void {
        this.loadSchedules();
    }

    private loadSchedules(): void {
        this.loadingSchedules = true;
        this.service.listSchedules(this.data.row.id).subscribe(
            (schedules) => {
                this.schedules = schedules;
                this.loadingSchedules = false;
            },
            () => {
                this.loadingSchedules = false;
                this.snack.open('Não foi possível carregar as consultas da indicação.', undefined, { duration: 3000 });
            }
        );
    }

    onAttached(): void {
        this.attachedAny = true;
        this.loadSchedules();
    }

    close(): void {
        this.dialogRef.close(this.attachedAny);
    }

    trackBySchedule(_index: number, schedule: IndicationScheduleOption): number {
        return schedule.id;
    }

    statusBadgeColor(status: string): 'success' | 'info' | 'warning' | 'danger' | 'neutral' {
        const map: Record<string, 'success' | 'info' | 'warning' | 'danger'> = {
            ativo: 'success',
            reagendado: 'info',
            cancelado: 'danger',
            'faltou à consulta': 'warning',
        };
        return map[status] ?? 'neutral';
    }

}
